module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "variation-selector"
  }, [_c('div', {
    staticClass: "variation-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.variationName))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('list-view', {
    staticClass: "variation-container"
  }, _vm._l((_vm.variations), function(variation) {
    return _c('div', {
      staticClass: "variation",
      attrs: {
        "selected": variation.selected
      },
      on: {
        "click": function($event) {
          _vm.variationSelected(variation.value)
        }
      }
    }, [_c('div', {
      staticClass: "variation-image",
      style: ({
        backgroundImage: variation.photoUrl
      })
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(variation.name))]), _vm._v(" "), (variation.price) ? _c('div', {
      staticClass: "variation-price"
    }, [_c('span', {
      staticClass: "price-unit"
    }, [_vm._v("+NT$")]), _vm._v(" " + _vm._s(_vm._f("priceTag")(variation.price)))]) : _vm._e()])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f8325fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/variation-selector.vue
// module id = 197
// module chunks = 5